import React from 'react'
import { graphql, gql, compose } from 'react-apollo'
import { withRouter } from 'react-router-dom'

import { translate } from 'react-i18next'
import { NotificationManager } from 'react-notifications'

import { Form, FileUploadInput } from '../../UI'
import Loader from '../../UI/Loader'

import USER_QUERY from './../../../graphql/UserByID.graphql'
import get from 'lodash/get'

import { makeFileSizeValidator, makeFileTypeValidator } from '../../../libs/validation'

const updatePlannerProfile = gql`
  mutation($id: ID!, $examplePlan: ID) {
    updatePlannerProfile(id: $id, examplePlanId: $examplePlan) {
      id
    }
  }
`

class ExamplePlanForm extends React.Component {
  state = {
    saving: false,
    routeIndex: 12
  }

  componentWillMount() {
    if (!this.props.data.loading && !this.props.data.user[0].plannerProfile) {
      this.props.history.push('/create-guru-profile/description')
    }
  }

  handleSubmit = values => {
    this.props.validate(this.state.routeIndex, true)
    if (!values.examplePlan) {
      if (Object.keys(this.props.validateData).length >= 12) {
        this.props.history.push('/create-guru-profile/finish')
      }

      return
    }
    this.setState({
      saving: true
    })
    let data = new FormData()
    data.append('data', values.examplePlan.file)
    fetch('https://api.graph.cool/file/v1/cj57v8algl0py0181lgmarwwx', {
      method: 'POST',
      body: data
    })
      .then(response => {
        return response.json()
      })
      .then(file => {
        return file.id
      })
      .then(fileId => {
        return this.props.updatePlannerProfile({
          variables: {
            id: this.props.data.user[0].plannerProfile.id,
            examplePlan: fileId
          }
        })
      })
      .then(result => {
        this.setState({
          saving: false
        })
        NotificationManager.success('Example plan updated', 'Success', 5000)
        if (Object.keys(this.props.validateData).length >= 12) {
          this.props.history.push('/create-guru-profile/finish')
        }
      })
      .catch(err => {
        this.setState({
          saving: false
        })
        NotificationManager.error('Error while updating example plan', 'Error', 5000)
      })
  }

  render() {
    const { t } = this.props

    if (this.props.data.loading) {
      return <Loader showLoader={true} />
    }
    const { saving } = this.state
    const { plannerProfile } = this.props.data.user[0]
    return (
      <div className="steps-screen__form faded-container">
        <div className="steps-screen__form-title">{t('example_file_title')}</div>
        <Form
          onSubmit={this.handleSubmit}
          submitBtnClassname="btn btn-lg btn-primary btn-danger"
          submitBtnName={t('main:save_continue')}
          submittingToServer={saving}
        >
          <div className="steps-screen__form-input-area">
            <div className="steps-screen__form-subtitle">{t('example_file_instructions')}</div>
            <div className="form-input-example">{t('example_file_spec')}</div>
            {plannerProfile.examplePlan && (
              <label className="steps-screen__form-input-label">
                {t('uploaded_file')}: {plannerProfile.examplePlan.name}
              </label>
            )}
            <FileUploadInput
              id="examplePlan"
              placeholder={t('main:browse')}
              isGroup={false}
              validationFuncs={[makeFileSizeValidator(10), makeFileTypeValidator('application/pdf', 'PDF')]}
            />
          </div>
        </Form>
      </div>
    )
  }
}

const enhance = compose(
  translate('guru'),
  graphql(updatePlannerProfile, {
    name: 'updatePlannerProfile'
  }),
  graphql(USER_QUERY, {
    options: props => ({
      variables: {
        id: get(props, 'user.id', '')
      },
      options: {
        fetchPolicy: 'network-only'
      }
    })   
  }),
  withRouter
)
export default enhance(ExamplePlanForm)



// WEBPACK FOOTER //
// src/components/Guru/CreateGuruProfile/ExamplePlanForm.jsx